import * as React from 'react';
import * as styles from './GalleryFooterMobile.css';

interface IGalleryFooterMobileProps {
  info: React.ReactNode;
  actions: React.ReactNode;
}

export const GalleryFooterMobile: React.FC<IGalleryFooterMobileProps> = ({ info, actions }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['info']}>{info}</div>
      <div className={styles['actions']}>{actions}</div>
    </div>
  );
};
